import React from 'react';
import Form, { Actions, EmailAddressValidator, Radio, RequiredValidator, TextField } from '../../../Components/Form';
import { useGrants } from '../../../Data/Business';
import Modal from '../../../Components/Modal';
import { usePlans } from '../../../Data/Plans';
import { useSession } from '../../../Components/Session';
import Money from '../../../Components/Formatting/Money';
import { PageLoading } from '../../../Components/Loading';
import Alert from '../../../Components/Alert';
import { useHelp } from '../../../Components/Help';

const AddUser = ({isOpen, setIsOpen, onChanged}) => {
    return <Modal title="Add user" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{onChanged}} />}
    </Modal>
}

const Inner = ({onChanged}) => {
    const {addUser} = useGrants();
    const {plans} = usePlans();
    const {plan} = useSession();
    const {showHelp} = useHelp();

    if (!plans || !plan) {
        return <PageLoading />;
    }

    const additionalUsers = plans.find(p => p.id === plan.id).additionalUsers;

    return <Form onSubmit={addUser} closeModalOnSubmit afterSubmit={onChanged}>

        <Alert type="info"
            icon="Info"
            title="Additional users"
            message="Learn more about additional users and how they work in getSoapy."
            onClick={() => showHelp('additionalUsers')}
        />

        <TextField name="email" label="Email" validators={[RequiredValidator, EmailAddressValidator]} />
        <Radio name="role"
            label="Role"
            layout="List"
            options={[
                {
                    label: 'Manager',
                    value: 'Manager',
                    help: <><Money pence={additionalUsers?.Manager} /> / month / manager</>
                },
                {
                    label: 'Worker',
                    value: 'Worker',
                    help: <><Money pence={additionalUsers?.Worker} /> / month / worker</>
                },
            ]}
            validators={[RequiredValidator]}
        />
        <Actions submit={{label: 'Add user'}} cancel />
    </Form>
}

export default AddUser;
